import React from 'react';
import PropTypes from 'prop-types';

function Close(props) {
    return (
        <span
            onClick={props.onClick}
            className="catalog-filter-section__action catalog-filter-section__action--close"
        />
    );
}

Close.propTypes = {
    onClick: PropTypes.func.isRequired
};

export { Close };
